module.exports = __webpack_public_path__ + "img/摄像机界面证书1.48ba6e59.jpg";